module.exports = __webpack_public_path__ + "static/media/prize-start.2cba1da2.png";